async function notify(blockId, pageName, eventName) {
  const input = $(`#input-${blockId}`).val()

  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  let error = false
  let success = false
  let email = input.trim()

  if (!email.length) {
    message = "Please enter a valid email address"
    error = true
  } else if (!re.test(email)) {
    message = "Invalid email address"
    error = true
  }

  if (!error) {
    let responseData = await fetch(
      "https://service.maanfarms.com/subscribe",
      {
        method: "POST",
        body: JSON.stringify({
          email: email,
          page: pageName,
          event_name: eventName,
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          message = "Thank you for subscribing."
          success = true
        } else {
          try {
            if (res.errors.length) {
              res.errors.forEach(
                function (error) {
                  if (error.error_code == 4001) {
                    message = "You have already subscribed."
                    error = true
                    success = false
                  } else {
                    message = "Internal server error"
                    error = true
                    success = false
                  }
                }.bind(this)
              )
            } else {
              message = "Internal server error"
              error = true
              success = false
            }
          } catch (err) {
            console.log(err)
            message = "Internal server error"
            error = true
            success = false
          }
        }
      })
      .catch((err) => {
        message = "Internal server error"
        error = true
        success = false
      })
  }

  const status = $(`#sl-message-${blockId}`)
  status.html(message)
  if (error) {
    status.addClass("error")
    status.removeClass("success")
  } else if (success) {
    status.addClass("success")
    status.removeClass("error")
  }
  // console.log("message", message)
  // console.log("error", error)
  // console.log("success", success)
}
